import { Component, OnInit } from '@angular/core';
import { CommonUtilityService } from '@app/services/common-utility.service';
import { environment } from '@env/environment';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-cart-navigation',
  template: '',
  styles: [],
  standalone: false,
})
export class CartNavigationComponent implements OnInit {
  selfServiceEnabled: boolean = environment?.selfServiceEnabled;
  constructor(
    private readonly commonUtilityService: CommonUtilityService,
    private readonly cookieService: CookieService,
  ) {}

  ngOnInit(): void {
    this.commonUtilityService.clearAllCookies(
      this.selfServiceEnabled,
      this.selfServiceEnabled,
      false,
      false,
      true,
    );
    this.cookieService.set(
      'isCart',
      JSON.stringify(true),
      0,
      '/',
      `${environment.cookieSubDomain}`,
    );
    this.commonUtilityService.onClickRedirectWTS('', '', true);
  }
}
